import { Component } from '@angular/core';

@Component({
  selector: 'mtm-blue-circle-icon',
  templateUrl: './blue-circle-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class BlueCircleIconComponent {}
